export default {"src":"/_next/static/media/audit.70c1be08.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};